import { render, staticRenderFns } from "./SwiperItem.vue?vue&type=template&id=43f90ab4&scoped=true"
import script from "./SwiperItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwiperItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SwiperItem.vue?vue&type=style&index=0&id=43f90ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f90ab4",
  null
  
)

export default component.exports